import React,{useEffect, useState} from "react";
import '../../../style/step-wizard.css'
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {ListAppraisalForLeader} from "../../../components/tasks/index";
import {Card,CardHeader,CardBody,CardTitle,Container,CardText,Row,Col,Progress,Table} from "reactstrap";
import {
    getAppraiseeDetails,
    GetReviewAppraiseeList,
    CheckAppraisalEnableState
  } from "../../../redux/actions/appraisal/appraisal.action";
const EmployeeAppraisalHome = React.memo((props) => { 
    var loginUser = JSON.parse(localStorage.getItem("user"));
    const {getAppraiseeDetails,GetReviewAppraiseeList,CheckAppraisalEnableState} = props;
    const {reviewAppraiseeList} = props.reviewAppraiseeList;
    const {appraisalEnableStatus} = props.appraisalEnableStatus;
    const[isShowAppraisalForm,setIsShowAppraisalForm] = useState(false);
    const[status,setStatus] = useState('');
    const[progress,setProgress] = useState('0');
     const [trow, setTrow] = useState([]);
    const {AppraiseeDetails} = props.AppraiseeDetails;
    const history = useHistory();
    let maxwidth="80vw";
    let currentYear1 =new Date().getFullYear();
    const NewAppraisal=()=>{
      history.push({
        pathname: "/empAppraisalHome",
          isReview:false
      })
      window.sessionStorage.clear();
    }
    const PreviousAppraisal=()=>{
        const currentYear = new Date().getFullYear(); // 2020   
        const previousYear =  currentYear-1;
        history.push("/previousPerformanceGoals")
        window.sessionStorage.setItem("year",previousYear);
        window.sessionStorage.setItem("type",1); //previous
    }
    const ReviewAppraisal=()=>{
      const currentYear = new Date().getFullYear(); // 2020   
      history.push("/previousPerformanceGoals")
      window.sessionStorage.setItem("year",currentYear);
      window.sessionStorage.setItem("type",2); // review
  }
  const ViewCurrentAppraisal=()=>{
    const currentYear = new Date().getFullYear(); // 2020   
    history.push("/previousPerformanceGoals")
    window.sessionStorage.setItem("year",currentYear);
    window.sessionStorage.setItem("type",3); //current
}

    useEffect(()=>{
        if(loginUser == null)
    {
      window.location.href = "/em";
    }
        getAppraiseeDetails(loginUser.EmployeeId);
        GetReviewAppraiseeList(loginUser.EmployeeId);
        CheckAppraisalEnableState(loginUser.EmployeeId);
      },[getAppraiseeDetails,GetReviewAppraiseeList,CheckAppraisalEnableState])
       
    useEffect(()=>{
        if(AppraiseeDetails!=undefined && AppraiseeDetails!=null){
          if(appraisalEnableStatus == true){
            setIsShowAppraisalForm(true);
          }
          else if(AppraiseeDetails.isAppraiseeSubmitted){
            setIsShowAppraisalForm(true)
          }     
           
            if(AppraiseeDetails.isAppraiseeSubmitted){
                setStatus("Submitted.");
                setProgress('50');
            }
            if(AppraiseeDetails.status == "Ready for review1")
            {
              setStatus("Ready for First Review.")
              setProgress('60')
            }
            if(AppraiseeDetails.status == "Ready for review2")
            {
              setStatus("Ready for Second Review.")
              setProgress('70')
            }
            if(AppraiseeDetails.status == "Ready for meeting"){
              setStatus("Ready for meeting.")
              setProgress('80')
            }
            if(AppraiseeDetails.isReviewCompleted){
                setStatus("Review Completed.")
                setProgress('90');
            }
            if(AppraiseeDetails.isMeetingDone){
                setStatus("Meeting Done.")
                setProgress('95');
            }
            if(AppraiseeDetails.isReviewCompleted){
              setStatus("Review Completed.")
              setProgress('100');
          }
           
        }
    },[AppraiseeDetails,appraisalEnableStatus])

    //Review Appraisal
    const reviewAppraisal = (appraiseeId,reviewType)=>{
        history.push({
            pathname: "/empAppraisalHome",
              empId: appraiseeId,
              isReview:true,
              ReviewType:reviewType
          })
          window.sessionStorage.clear();
          window.sessionStorage.setItem("isReview",true);
          window.sessionStorage.setItem("ReviewEmpId",appraiseeId);
          window.sessionStorage.setItem("ReviewType",reviewType);
    }
const reviewFromYear = AppraiseeDetails?.reviewPeriodFrom
  ? new Date(AppraiseeDetails.reviewPeriodFrom).getFullYear()
  : "";

const reviewToYear = AppraiseeDetails?.reviewPeriodTo
  ? new Date(AppraiseeDetails.reviewPeriodTo).getFullYear()
  : "";

    return(
        <div>
         <Container>
         <Row>
        <Col>
          <h3>Appraisal</h3>
        </Col>
      </Row>
      <Card>
        <CardBody>
      <h5>Self Appraisal</h5>
        <Row>
            <Col md={6}>
            <Card>
            <CardHeader style={{ fontWeight: "800", backgroundColor: "antiquewhite" }}>
  Previous Appraisal {reviewFromYear && reviewToYear
    ? `${reviewFromYear} - ${reviewToYear}`
    : ""}
</CardHeader>

                <CardBody>
                    <CardTitle>Previous Year Performance Goals</CardTitle>
                    <CardText>View your previous Appraisal Performance goals here.</CardText>
                    <input type="button" value="Previous Appraisal Goals" className='btn-admin-settings btn' onClick={PreviousAppraisal}/>
                </CardBody>
             </Card>
            </Col>
            <Col md={6}>
            {(appraisalEnableStatus == true ||AppraiseeDetails.isAppraiseeSubmitted == true)?
            (
              <Card>
              <CardHeader style={{fontWeight: '800',backgroundColor:'#cdeae0'}}>New Appraisal {currentYear1}</CardHeader>
                  <CardBody>
                      <CardTitle>Appraisal Form</CardTitle>
                      {isShowAppraisalForm == true && AppraiseeDetails.isAppraiseeSubmitted == false?(
                          <div>
                          <CardText>Fill your current year Appraisal form here.</CardText>
                           <input type="button" value="Go to New Appraisal" className='btn-admin-settings btn' onClick={NewAppraisal}/>
                          </div>
                          
                      ):(
                          <div>          
                                
                                  {(!AppraiseeDetails.isReviewCompleted)?
                                  (
                                    <div>
                                      <Row>
                                  <Col md={7}><CardText>Status : {status} </CardText></Col>
                                  <Col md={5}> {(AppraiseeDetails.isMeetingDone && !AppraiseeDetails.isReviewCompleted)?                                   
                                    <input type="button" value="Review Appraisal" className='btn-admin-settings btn' onClick={ReviewAppraisal}/>
                                    :null}   
                                   </Col>
                                  </Row>
                                    <div className="mt-2 mb-1">
                                    Progress
                                    <span className="text-success float-right">{progress}%</span>
                                    </div>
                                    <Progress value={progress} style={{ height: "6px" }}></Progress>
                                    </div>
                                  ):
                                  (
                                    
                                    <div>
                                     <Row>
                                  <Col md={7}><CardText>Status : {"Not Enabled"} </CardText></Col>
                                  <Col md={5}> {(AppraiseeDetails.isMeetingDone && !AppraiseeDetails.isReviewCompleted)?                                   
                                    <input type="button" value="Review Appraisal" className='btn-admin-settings btn' onClick={ReviewAppraisal}/>
                                    :null}   
                                   </Col>
                                  </Row>
                                    <div className="mt-2 mb-1">
                                    <span>Your Appraisal is not enabled for the year, Please contact Admin.</span>
                                    </div>
                                    <Progress value={progress} style={{ height: "6px" }}></Progress>
                                    </div>
                                  )}
                                 
                                  
                          </div>
                      )}
                     
                  </CardBody>
               </Card>    
             
            ):(
              <Card>
              <CardHeader style={{fontWeight: '800',backgroundColor:'#cdeae0'}}>New Appraisal {currentYear1}</CardHeader>
                  <CardBody>
                      <CardTitle>Appraisal Form</CardTitle>
                      {isShowAppraisalForm?(
                          <div>
                          <CardText>Fill your current year Appraisal form here.</CardText>
                           <input type="button" value="Go to New Appraisal" className='btn-admin-settings btn' onClick={NewAppraisal}/>
                          </div>
                          
                      ):(
                          <div>          
                                <Row>
                                  <Col md={7}><CardText>Status : {"Not Enabled"} </CardText></Col>
                                  <Col md={5}> {(AppraiseeDetails.isMeetingDone && !AppraiseeDetails.isReviewCompleted)?                                   
                                    <input type="button" value="Review Appraisal" className='btn-admin-settings btn' onClick={ReviewAppraisal}/>
                                    :null}   
                                   </Col>
                                  </Row>
                                 
                                    <div>
                                    <div className="mt-2 mb-1">
                                    <span>Your Appraisal is not enabled for the year, Please contact Admin.</span>
                                    </div>
                                    <Progress value={progress} style={{ height: "6px" }}></Progress>
                                    </div>
                                
                                 
                                  
                          </div>
                      )}
                     
                  </CardBody>
               </Card>   
            )}
           
           </Col>
              </Row>
              </CardBody>
        </Card>
            <Card className="flex-fill">
      <CardBody>
        <CardTitle>
                <h5>Review List</h5>
                <span>(List of employees whose appraisals you need to review.)</span>
        </CardTitle>
       {reviewAppraiseeList.length > 0 ? ( <ListAppraisalForLeader
         
                               reviewAppraiseeList={reviewAppraiseeList}
                               reviewAppraisal={reviewAppraisal}
                              
                             ></ListAppraisalForLeader>): null} 
      </CardBody>
    </Card>
            </Container>
      
      </div>
    )
});
const mapStateToProps = (state) => ({
    AppraiseeDetails : state.appraisalReducer,
    reviewAppraiseeList : state.appraisalReducer,
    appraisalEnableStatus : state.appraisalReducer
});
export default connect(mapStateToProps, {
    getAppraiseeDetails,
    GetReviewAppraiseeList,
    CheckAppraisalEnableState
})(EmployeeAppraisalHome);